import { render, staticRenderFns } from "./TipoColegioPage.vue?vue&type=template&id=9e53f1d4&"
import script from "./TipoColegioPage.js?vue&type=script&lang=js&"
export * from "./TipoColegioPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports